"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatDependencies = void 0;
var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");
var _factoriesAny = require("../../factoriesAny.js");
/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */

var formatDependencies = exports.formatDependencies = {
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createFormat: _factoriesAny.createFormat
};